import React from 'react';
import PropTypes from 'prop-types';

import FormHeader from '../../../../../../components/FormHeader';

const TransactionFormHeader = (props) => {
  const {
    onCreateCashbackButtonClick,
    onDeleteCashbackButtonClick,
    onEditTransactionButtonClick,
    showCreateCashbackButton,
    showDeleteCashbackButton,
  } = props;

  return (
    <FormHeader title="Transaction Details">
      <button className="button" onClick={onEditTransactionButtonClick}>
        Edit Transaction
      </button>
      {showCreateCashbackButton && (
        <button
          className="button -in-group"
          onClick={onCreateCashbackButtonClick}
        >
          Create Cashback
        </button>
      )}
      {showDeleteCashbackButton && (
        <button
          className="button delete -in-group"
          onClick={onDeleteCashbackButtonClick}
        >
          Delete Cashback
        </button>
      )}
    </FormHeader>
  );
};

TransactionFormHeader.propTypes = {
  onCreateCashbackButtonClick: PropTypes.func.isRequired,
  onDeleteCashbackButtonClick: PropTypes.func.isRequired,
  onEditTransactionButtonClick: PropTypes.func.isRequired,
  showCreateCashbackButton: PropTypes.bool.isRequired,
  showDeleteCashbackButton: PropTypes.bool.isRequired,
};

export default TransactionFormHeader;
